import { clsx } from "clsx"
import { forwardRef, type MouseEvent } from "react"

import type { SX } from "../../theme"
import { Icon, type IconName } from "../Icon"
import styles from "./HairlineButton.module.css"

export interface HairlineButtonProps {
  icon: IconName
  disabled?: boolean
  dropMode?: boolean
  sx?: SX
  onClick?: (event: MouseEvent) => void
}

export const HairlineButton = forwardRef<
  HTMLButtonElement,
  HairlineButtonProps
>(function HairlineButton(props, ref) {
  const { icon, dropMode, disabled = false, sx, ...otherProps } = props

  const mode = dropMode ? "drop" : "normal"

  return (
    <button
      {...otherProps}
      className={clsx(styles.hairlineButton, styles[`root-mode-${mode}`])}
      style={sx}
      disabled={disabled}
      ref={ref}
    >
      <div
        className={clsx(
          styles.line,
          styles.firstLine,
          styles[`line-mode-${mode}`]
        )}
      />

      <div className={clsx(styles.icon, styles[`icon-mode-${mode}`])}>
        <Icon name={icon} size="large" color="grey2" />
      </div>

      <div
        className={clsx(
          styles.line,
          styles.secondLine,
          styles[`line-mode-${mode}`]
        )}
      />
    </button>
  )
})
